export default __webpack_public_path__ + "static/media/ic_adviser_2.617cb575.svg";